import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import useGiftOrderInfo from './hooks/useGiftOrderInfo';

declare module '@stackflow/config' {
    interface Register {
        GiftOrderCompleteActivity: {
            orderNo: string
        }
    }
}

const GiftOrderCompleteActivity: ActivityComponentType<'GiftOrderCompleteActivity'> = ({ params }) => {
    const { orderNo } = params;
    useGiftOrderInfo(orderNo);
    return (
        <AppScreen>
            <Loading/>
        </AppScreen>
    );
};

export default GiftOrderCompleteActivity;
